// src/Pages/Products.js

import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "../Styles/Products.css";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";

function Products() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: false,
      mirror: true,
    });
  }, []);

  return (
    <div className="products-container">
      {/* Hero Section with Embedded YouTube Video */}
      <section className="hero-section">
        <Navbar />
        <div className="hero-content" data-aos="fade-in">
          <h1>Our Products</h1>
          <p>
            Discover our innovative tools designed <br /> to simplify systems engineering. 
            <br /><br />
            <strong>Want exclusive access?</strong><br /> Visit our{" "}
            <Link to="/contact-us" className="hero-access-link">
              Product Access
            </Link>{" "}
            page to learn more.
          </p>
        </div>
        <div className="hero-video" data-aos="fade-up">
          <iframe
            className="video-embed"
            // We enable controls=1 so the user can pause/play, unmute, and seek forward/backward
            src="https://www.youtube.com/embed/mHcAsPCgyT0?autoplay=1&mute=1&loop=1&playlist=mHcAsPCgyT0&controls=1&modestbranding=1&rel=0&iv_load_policy=3"
            title="RoboFication: Your AI Systems Engineer"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </section>

      {/* Products Listing Section */}
      <section className="products-section">
        <h2 data-aos="fade-right">Our Tools</h2>
        <div className="products-grid">
          {/* 5. Robo Huddle Room */}
          <div className="product-card" data-aos="zoom-in" data-aos-delay="500">
            <div className="product-image">
              <img
                src="/products_images/robohuddleroom.jpg"
                alt="Robo Huddle Room"
              />
            </div>
            <h3>Robo Huddle Room</h3>
            <p>
              A virtual space for engineering collaboration and design
              automation. Huddle Room is an innovative app designed for
              engineers and teams to collaborate in virtual meetings, fostering
              creativity and efficiency in generating ideas, architectures, and
              designs. This platform automates the creation of system models,
              architectures, requirements, and comprehensive documentation.
            </p>
          </div>
          {/* 1. Robo SysML */}
          <div className="product-card" data-aos="zoom-in">
            <div className="product-image">
              <img src="/products_images/robosysml.jpg" alt="Robo SysML" />
            </div>
            <h3>Robo SysML</h3>
            <p>
              Robo SysML is an AI-powered webapp that transforms your code into
              SysML diagrams automatically. By leveraging cutting-edge
              technology, it simplifies systems engineering, enabling developers
              to visualize and analyze complex systems efficiently.
            </p>
          </div>

          {/* 2. Robo Code Analyzer (CLI) */}
          <div className="product-card" data-aos="zoom-in" data-aos-delay="100">
            <div className="product-image">
              <img
                src="/products_images/robocodeanalyzer.jpg"
                alt="Robo Code Analyzer (CLI)"
              />
            </div>
            <h3>Robo Code Analyzer (CLI)</h3>
            <p>
              A command-line tool for performing automated systems analysis
              directly on codebases and repositories. Tailored for developers,
              this tool identifies potential hazards and automatically generates
              requirements to mitigate them—all within minutes. The process,
              which traditionally takes weeks or months, is now streamlined and
              requires no specialized input.
            </p>
          </div>

          {/* 3. Robo Model Analyzer */}
          <div className="product-card" data-aos="zoom-in" data-aos-delay="200">
            <div className="product-image">
              <img
                src="/products_images/robomodelanalyzer.jpg"
                alt="Robo Model Analyzer"
              />
            </div>
            <h3>Robo Model Analyzer</h3>
            <p>
              This command-line tool brings automated systems analysis to model
              repositories, enabling engineers to assess and ensure system
              safety early in the design process. By identifying hazards and
              generating necessary requirements, it accelerates compliance
              during model-driven development.
            </p>
          </div>

          {/* 4. Robo Systems Engineer (Desktop) */}
          <div className="product-card" data-aos="zoom-in" data-aos-delay="300">
            <div className="product-image">
              <img
                src="/products_images/robosystemsengineerdesk.jpg"
                alt="Robo Systems Engineer (Desktop)"
              />
            </div>
            <h3>Robo Systems Engineer</h3>
            <p>
              A versatile application designed for collaborative systems
              analysis, enabling teams to initiate safety analysis with minimal
              information or based on detailed code or model inputs. The suite
              supports real-time collaboration across distributed teams,
              allowing users to generate, refine, and customize safety
              requirements. It offers extensive customization options to adapt
              to different workflows
            </p>
          </div>
        </div>
      </section>

      {/* Footer Section */}
      <Footer />
    </div>
  );
}

export default Products;
